/** @format */
import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { CourseUnitRealisation, EnrolmentQuestionnaire, EnrolmentQuestionnaireAnswers } from 'common-typescript/dist/typings/types';
import { CourseUnit, LocalizedString } from 'common-typescript/types';
import { LocaleService } from 'sis-common/l10n/locale.service';

export interface EnrolmentQuestionnaireModalValues {
    enrolmentQuestionnaire: EnrolmentQuestionnaire;
    enrolmentQuestionnaireAnswers: EnrolmentQuestionnaireAnswers;
    courseUnitRealisation: CourseUnitRealisation;
    courseUnit: CourseUnit;
}

export function enrolmentQuestionnaireModalOpener(): (
    data: EnrolmentQuestionnaireModalValues,
) => MatDialogRef<EnrolmentQuestionnaireModalNewComponent, void> {
    const _dialogService = inject(FudisDialogService);
    return data => _dialogService.open(EnrolmentQuestionnaireModalNewComponent, { data });
}

@Component({
    selector: 'sis-enrolment-questionnaire-modal',
    templateUrl: './enrolment-questionnaire-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnrolmentQuestionnaireModalNewComponent implements OnInit {
    readonly data: EnrolmentQuestionnaireModalValues = inject(MAT_DIALOG_DATA);

    readonly _localeService = inject(LocaleService);

    courseUnitName: LocalizedString;
    courseUnitRealisationName: LocalizedString;
    hasQuestions: boolean;
    questionAnswers: {
        id: string;
        question: LocalizedString;
        answer: string | undefined;
        isLanguageSelection: boolean;
    }[] = [];

    ngOnInit(): void {
        this.courseUnitName = this.data?.courseUnit?.name;
        this.courseUnitRealisationName = this.data?.courseUnitRealisation?.name;
        this.hasQuestions = this.data?.enrolmentQuestionnaire?.enrolmentQuestions?.length > 0;

        if (this.hasQuestions) {
            const qa = this.data.enrolmentQuestionnaire.enrolmentQuestions.map(question => {
                const answer = this.data.enrolmentQuestionnaireAnswers?.answers?.find(a => a.questionId === question.localId);

                if (question.questionType === 'LANGUAGE_SELECT') {
                    return {
                        id: question.localId,
                        question: this._localeService.getLocalizedString('ENROLMENT_QUESTIONS.LANGUAGE_SELECTION'),
                        answer: answer?.selections?.length > 0 ? answer.selections[0] : undefined,
                        isLanguageSelection: true,
                    };
                }
                return {
                    id: question.localId,
                    question: question.question,
                    answer: answer !== undefined ? answer.answerText : undefined,
                    isLanguageSelection: false,
                };
            });

            this.questionAnswers = [...qa];
        }
    }
}
